module.exports = __webpack_public_path__ + "static/commercial-1-6f8d2da7f1f020128d0e57818a129494.jpg";